module.exports = __webpack_public_path__ + "static/img/mj.8bed666.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/mj.jpg
// module id = 3tTe
// module chunks = 153